import { Box, IconButton, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import { type FC, useState } from "react"

import { PackagingWarehouseInstructionsSection } from "./PackagingWarehouseInstructionsSection"

import type { PreferenceAssociationItem } from "@/screens/CustomerProducts/hooks/useProductPreferenceAssociationList"

interface PackagingWarehouseInstructionsPanelProps {
  association: PreferenceAssociationItem
  companyId: string
  productId: number
}

export const PackagingWarehouseInstructionsPanel: FC<PackagingWarehouseInstructionsPanelProps> = ({
  association,
  companyId,
  productId,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const { companyProductAssociationLocationId } = association
  if (!companyProductAssociationLocationId) return null

  return (
    <Box className='rounded-md border border-solid border-gray-400 p-6'>
      <Box className='mb-6 flex items-center justify-between'>
        <Typography className='text-ml font-normal text-gray-900'>Packaging & Warehouse Instructions</Typography>
        <IconButton
          size='small'
          onClick={() => setIsExpanded((prev) => !prev)}
          data-testid='customer-product.packaging-warehouse-panel.expand-button'
        >
          {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>

      {isExpanded && (
        <PackagingWarehouseInstructionsSection
          key={companyProductAssociationLocationId}
          companyProductAssociationLocationId={companyProductAssociationLocationId}
          companyId={companyId}
          productId={productId}
          warehouseInstructions={association.warehouseInstructions ?? null}
          bolNotes={association.bolNotes ?? null}
        />
      )}
    </Box>
  )
}
